import * as Output from './index';
Output.DeepMerger.merge(Output);
